import { addError, removeError, clearErrors } from '../slices/errorSlice';
import { v4 as uuidv4 } from 'uuid'; // To generate unique IDs for errors

/**
 * Dispatch a new error to the Redux store.
 * @param {Function} dispatch - Redux dispatch function.
 * @param {Object} errorDetails - The error details (type, message, component, etc.).
 */
export const logError = (dispatch, errorDetails) => {
  const error = {
    id: uuidv4(), // Generate a unique ID for the error
    timestamp: new Date().toISOString(), // Add a timestamp
    ...errorDetails, // Merge the provided details
  };
  dispatch(addError(error));
};

/**
 * Remove an error by its ID.
 * @param {Function} dispatch - Redux dispatch function.
 * @param {string} errorId - The ID of the error to remove.
 */
export const dismissError = (dispatch, errorId) => {
  dispatch(removeError(errorId));
};

/**
 * Clear all errors from the Redux store.
 * @param {Function} dispatch - Redux dispatch function.
 */
export const clearAllErrors = (dispatch) => {
  dispatch(clearErrors());
};
